import { render } from "./MainInternalTransferOfProducts.vue?vue&type=template&id=4be730cb"
import script from "./MainInternalTransferOfProducts.vue?vue&type=script&lang=js"
export * from "./MainInternalTransferOfProducts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__